import { TaxonomyActionType } from '@modules/taxonomy/store/taxonomyActionType';
import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import { FormatQuoteRounded, OpenInFullRounded } from '@mui/icons-material';
import { IconButton, Paper, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { CreateNewReasonV3Modal } from '../CreateNewReasonV3Modal';
import { trackCreateNewReasonEvents } from '../CreateNewReasonV3Modal/helpers';

export const CreateNewReasonModalMinimizedView = () => {
  const [isCreateReasonModalOpen, setIsCreateReasonModalOpen] = useState(false);

  const dispatch = useTaxonomyStore(({ dispatch }) => dispatch);
  const isV3ModalMinimised = useTaxonomyStore(
    ({ createReasonV3State: { visual } }) => visual?.isModalMinimised,
  );

  const openCreateReasonModal = () => {
    setIsCreateReasonModalOpen(true);
    dispatch({
      type: TaxonomyActionType.SET_CREATE_REASONV3_STATE,
      payload: {
        visual: {
          isModalMinimised: false,
        },
      },
    });

    trackCreateNewReasonEvents({
      eventName: 'Create New Reason - Maximize CTA Clicked',
    });
  };

  return (
    <>
      {isV3ModalMinimised && (
        <Paper
          elevation={5}
          sx={{
            position: 'fixed',
            zIndex: 2401,
            width: 300,
            bottom: 0,
            left: 100,
            px: 2,
            py: 1,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
            backgroundColor: (theme) => theme.palette.primary.dark,
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <FormatQuoteRounded
                sx={{ color: (theme) => theme.palette.primary.contrastText }}
              />
              <Typography
                variant="subtitle2"
                sx={{ color: (theme) => theme.palette.primary.contrastText }}
              >
                Create new Reason
              </Typography>
            </Stack>
            <IconButton
              size="small"
              onClick={openCreateReasonModal}
              sx={{ color: (theme) => theme.palette.primary.contrastText }}
            >
              <OpenInFullRounded />
            </IconButton>
          </Stack>
        </Paper>
      )}
      <CreateNewReasonV3Modal
        open={isCreateReasonModalOpen}
        onClose={() => setIsCreateReasonModalOpen(false)}
      />
    </>
  );
};
